export default __webpack_public_path__ + "static/media/cholet15.39fe292f.jpg";